import { Services } from '@sigma-frontend-libs/commons'

import { components } from '@/utils'

import selectorSendingType from '@/components/selector/sendingType'
import { getChannelTypes } from '@/components/services/otp-settings/utils'

const serviceNameViaPoint = Services['otp-settings/channels'].split('/').join('.')

function renderNameField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.search,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.name`),
        dense: true,
        clearable: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.search = event
        }
      }
    }
  )
}

function renderChannelTypeField(h) {
  return h(
    selectorSendingType,
    {
      props: {
        value: this.proxy.channelType,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.channelType`),
        items: getChannelTypes(Services['otp-settings/channels']),
        dense: true,
        rounded: true,
        clearable: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.channelType = event
        }
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: `${serviceNameViaPoint.replace('.', '-')}-filter`
    },
    [
      renderNameField.call(this, h),
      renderChannelTypeField.call(this, h)
    ]
  )
}
